<script setup>
    import {
        AuthenticationCard,
        AuthenticationCardLogo,
        Checkbox,
        InputError,
        InputLabel,
        PrimaryButton,
        TextInput,
    } from '@/components/shared'

    import { useForm } from '@inertiajs/vue3'

    defineProps({
        canResetPassword: Boolean,
        status: String,
    })

    const form = useForm({
        email: '',
        password: '',
        remember: false,
    })

    const submit = () => {
        form.transform((data) => ({
            ...data,
            remember: form.remember ? 'on' : '',
        })).post(route('login'), {
            onFinish: () => form.reset('password'),
        })
    }
</script>

<template>
    <Head title="Přihlásit se" />

    <AuthenticationCard>
        <template #logo>
            <AuthenticationCardLogo />
        </template>

        <div
            v-if="status"
            class="mb-4 text-sm font-medium text-green-600"
        >
            {{ status }}
        </div>

        <form
            class="space-y-6"
            @submit.prevent="submit"
        >
            <div>
                <InputLabel
                    for="email"
                    value="Email"
                />
                <TextInput
                    id="email"
                    v-model="form.email"
                    type="email"
                    class="mt-1 block w-full"
                    autofocus
                    autocomplete="username"
                />
                <InputError
                    class="mt-2"
                    :message="form.errors.email"
                />
            </div>

            <div class="">
                <InputLabel
                    for="password"
                    value="Heslo"
                />
                <TextInput
                    id="password"
                    v-model="form.password"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="current-password"
                />
                <InputError
                    class="mt-2"
                    :message="form.errors.password"
                />
            </div>

            <div class="flex items-center justify-between">
                <div class="flex gap-3">
                    <label class="flex items-center">
                        <Checkbox
                            v-model:checked="form.remember"
                            name="remember"
                        />
                        <span class="ms-2 text-sm text-gray-600">Zapamatovat si mě</span>
                    </label>
                </div>
            </div>

            <div>
                <PrimaryButton
                    class="flex w-full justify-center"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    Přihlásit se
                </PrimaryButton>
            </div>
        </form>
    </AuthenticationCard>
</template>
